import React from "react";
import { useState, useEffect, useContext } from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import { Row } from "react-bootstrap";
import PerformersData from "../pages/PerformersData";
import PerformersActivity from "../pages/PerformersActivity";
import { ThemeProvider } from "@mui/material/styles";
import { theme } from "../components/theme";
import FindUser from "../pages/FindUser";
import VN from "../components/VN";
import { UserDataContext } from "../components/UserDataContext";
import { useNavigate } from "react-router-dom";

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;
  const navigate = useNavigate();
  const { userData } = useContext(UserDataContext);

  useEffect(() => {
    if (userData && userData.permId === "2") {
      navigate("/nopermission");
    }
  }, [userData, navigate]);

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

export default function Performers() {
  const { userData } = useContext(UserDataContext);
  const [value, setValue] = useState(0);
  const handleChange = (event, newValue) => {
    setValue(newValue);
    localStorage.setItem("selectedTabPerformers", newValue);
  };

  useEffect(() => {
    const savedTab = localStorage.getItem("selectedTabPerformers");
    if (savedTab) {
      setValue(parseInt(savedTab, 10));
    }
  }, []);

  return (
    <div>
      <VN userData={userData} />
      {/*
      <Box sx={{ width: "100%" }}>
       */}

      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <ThemeProvider theme={theme}>
          <Tabs
            value={value}
            onChange={handleChange}
            aria-label="underMenu"
            variant="scrollable"
            scrollButtons
            allowScrollButtonsMobile
          >
            <Tab label="Wykonawcy" />
            <Tab label="Znajdź wykonawców wg uprawnień" />
            <Tab label="Aktywność" />
          </Tabs>
        </ThemeProvider>
      </Box>

      <CustomTabPanel value={value} index={0}>
        <Row>
          <PerformersData />
        </Row>
      </CustomTabPanel>

      <CustomTabPanel value={value} index={1}>
        <Row>
          <FindUser />
        </Row>
      </CustomTabPanel>

      <CustomTabPanel value={value} index={2}>
        <Row>
          <PerformersActivity perm="2" />
        </Row>
      </CustomTabPanel>
    </div>
  );
}
